// You can write more code here

/* START OF COMPILED CODE */

import LaneEntityImageBase from "../LaneEntityImageBase";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class LaneEntityImage extends LaneEntityImageBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 45, y ?? 45, texture || "common", frame ?? "icon-taxi-tom.png");

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  public spawnOffsetY: number = 0;
  public spawnOffsetSpineY: number = 0;

  /* START-USER-CODE */

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
